import React from "react";

const Echec = ({message}) => 
    <div className="alert alert-danger">
        <div>{message}</div>
    </div>

export default Echec